export default __webpack_public_path__ + "static/media/builtForOver2Years.c791087b.svg";